export default __webpack_public_path__ + "static/media/icon-20-icn-event-turn-1.27b4e7ec.svg";